// src/utils/assessment/transformers.js
// Helper functions to transform assessment answers and build payloads

/**
 * Transform the answers object into the array format expected by the backend.
 *
 * @param {Record<string, any>} answers
 * @param {Array<{ id: string }>} questions
 */
export const transformAnswers = (answers, questions) => {
  if (!answers) return [];

  return Object.keys(answers).map((questionId) => {
    const question = questions?.find((q) => q.id === questionId);

    return {
      question_id: questionId,
      answer: answers[questionId],
      question_type: question?.question_type || 'text'
    };
  });
};

/**
 * Build the assessment payload for submission.
 *
 * @param {Object} params
 * @param {Object} params.facilityInfo
 * @param {Object} params.energyBaseline
 * @param {Record<string, any>} params.answers
 * @param {Array} params.questions
 * @param {Object|null} params.user
 * @param {string} params.type
 * @param {string|undefined} params.region
 */
export const buildAssessmentPayload = ({
  facilityInfo,
  energyBaseline,
  answers,
  questions,
  user,
  type,
  region
}) => {
  const transformedAnswers = transformAnswers(answers, questions);
  const userId = user?.user_id || user?.id || null;

  return {
    facility_name: facilityInfo.companyName,
    industry_name: facilityInfo.majorIndustry,
    region: region || 'naics',
    assessment_type: type,
    user_id: userId,
    answers: transformedAnswers,
    metadata: {
      contact_name: facilityInfo.contactName,
      contact_email: facilityInfo.email,
      sub_industry: facilityInfo.subIndustry,
      energy_baseline: energyBaseline,
      state: facilityInfo.state,
      jurisdiction: facilityInfo.state
    }
  };
};


